import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import CustomCollapse from "../UI/CustomCollapse";
import FlashCardTableList from "./FlashCardTableList";
import { connect } from "react-redux";
import {
  getMyFlashCards,
  getPublicFlashCards,
} from "../../ducks/FlashCardDucks";
import { axiosPost } from "../../utils/AxiosApi";
import { checkWidgetAdminOrNot, draggable, URL } from "../../utils/Constants";
import swal from "sweetalert";
import { MESSAGEHEADER } from "../../utils/DisplayMessage";
import ModalWindow from "../UI/ModalWindow";
import UpdateFlashCardSet from "./UpdateFlashCardSet";
import UpdateFlashCards from "./UpdateFlashCards";
import { displayConfirmDeleteAlert } from "../../utils/Utils";
import GranularPermissionModal from "../Permissions/GranularPermissionModal";
import CustomModal from "../common/CustomModal";

class ListFlashCards extends Component {
  state = {
    cardType: [
      { name: "My Flash Cards Set", open: false, code: "my" },
      { name: "Public Flash Cards Set", open: false, code: "public" },
    ],
    publicFlashCards: [],
    publicSpinner: false,
    myFlashCards: [],
    mySpinner: false,
    title: "",
    description: "",
    access: "",
    updateModal: false,
    id: "",
    selectedCard: "",
    flashCardsUpdateModal: false,
    codeIdx: "",
    updateMyFlashCards: [],
    searchText: "",
    publicFlashOffset: 0,
    publicFlashCurrentPage: 1,
    publicFlashRowCountLimit: 8,
    publicFlashTotalRecords: 0,
    permissionModal: false,
  };

  componentDidMount() {
    this.props.getPublicFlashCards(
      this.state.searchText,
      this.state.publicFlashOffset,
      this.state.publicFlashRowCountLimit,
    );
    this.props.getMyFlashCards();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.myFlashCards !== this.props.myFlashCards) {
      const selected = this.props.myFlashCards.find(
        (card) => card.id === this.state.selectedCard.id,
      );

      if (selected) {
        const code = parseInt(
          selected.flashCards[selected.flashCards.length - 1].code.replace(
            "Flash-Card",
            "",
          ),
        );

        this.setState({
          selectedCard: selected,
          codeIdx: code,
        });
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      myFlashCards: nextProps.myFlashCards,
      publicFlashCards: nextProps.publicFlashCards,
      publicFlashTotalRecords: nextProps.publicFlashTotalRecords,
      publicSpinner: nextProps.publicSpinner,
      mySpinner: nextProps.mySpinner,
    };
  }

  toggleCollapsible = (e, idx) => {
    let cardType = this.state.cardType;
    if (cardType[idx].open === true) {
      cardType.forEach((el) => {
        el.open = false;
      });
    } else {
      cardType.forEach((el) => {
        el.open = false;
      });
      cardType[idx].open = true;
    }
    this.setState({ cardType });
  };

  displayList = (type) => {
    let cardList = "";
    let spinner = "";
    let cardType = "";
    if (type.code === "public") {
      cardList = this.state.publicFlashCards;
      spinner = this.state.publicSpinner;
      cardType = "public";
    } else {
      cardList = this.state.myFlashCards;
      spinner = this.state.mySpinner;
      cardType = "my";
    }
    return (
      <FlashCardTableList
        cardList={cardList}
        spinner={spinner}
        cardType={cardType}
        deleteFlashCardSet={this.deleteFlashCardSet}
        handleUpdateModal={this.handleUpdateModal}
        publicFlashOffset={this.state.publicFlashOffset}
        publicFlashCurrentPage={this.state.publicFlashCurrentPage}
        publicFlashRowCountLimit={this.state.publicFlashRowCountLimit}
        publicFlashTotalRecords={this.state.publicFlashTotalRecords}
        handlePageChange={this.handlePageChange}
        handleNextPage={this.handleNextPage}
        handlePreviousPage={this.handlePreviousPage}
      ></FlashCardTableList>
    );
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  //Delete Flash Card

  deleteFlashCardSet = (id) => {
    let data = { id: id };
    axiosPost(URL.deleteFlashCardSet, data, (response) => {
      if (response.status === 200) {
        this.setState(
          {
            publicFlashOffset: 0,
            publicFlashCurrentPage: 1,
            publicFlashRowCountLimit: 8,
            publicFlashTotalRecords: 0,
          },
          function () {
            this.props.getPublicFlashCards(
              this.state.searchText,
              this.state.publicFlashOffset,
              this.state.publicFlashRowCountLimit,
            );
            this.props.getMyFlashCards();
          },
        );
      }
    });
  };

  //udpate Flash Card Set
  handleUpdateModal = (cards) => {
    let code = cards.flashCards[cards.flashCards.length - 1].code;
    code = code.replace("Flash-Card", "");
    code = parseInt(code);
    this.setState({
      updateModal: !this.state.updateModal,
      title: cards.title,
      description: cards.description,
      access: cards.access,
      id: cards.id,
      selectedCard: cards,
      codeIdx: code,
    });
  };

  toggleUpdateModal = () => {
    this.setState({
      updateModal: !this.state.updateModal,
      title: "",
      description: "",
      access: "",
      id: "",
      selectedCard: "",
    });
  };

  updateFlashCardSet = () => {
    let data = {
      id: this.state.id,
      title: this.state.title,
      description: this.state.description,
      access: this.state.access,
    };
    axiosPost(URL.updateFlashCardSet, data, (response) => {
      if (response.status === 200) {
        swal({
          title: MESSAGEHEADER.success,
          text: response.data.message,
          closeOnClickOutside: false,
          allowOutsideClick: false,
        });
        draggable();
        this.props.getPublicFlashCards(
          this.state.searchText,
          this.state.publicFlashOffset,
          this.state.publicFlashRowCountLimit,
        );
        this.props.getMyFlashCards();
        this.toggleUpdateModal();
      }
    });
  };

  setSelectedCard = (card) => {
    this.setState({ selectedCard: card });
  };

  //Update Flash Cards
  handleUpdateFlashCardModal = () => {
    this.setState({
      flashCardsUpdateModal: !this.state.flashCardsUpdateModal,
    });
  };

  getMyFlashCardsUpdate = () => {
    this.props.getMyFlashCards();
  };

  searchPublicFlashCard = () => {
    this.setState(
      {
        publicFlashOffset: 0,
        publicFlashCurrentPage: 1,
        publicFlashRowCountLimit: 8,
        publicFlashTotalRecords: 0,
      },
      function () {
        this.props.getPublicFlashCards(
          this.state.searchText,
          this.state.publicFlashOffset,
          this.state.publicFlashRowCountLimit,
        );
      },
    );
  };

  //Pagination

  handlePreviousPage = () => {
    if (this.state.publicFlashCurrentPage !== 1) {
      this.reRenderPublicFlashCard(this.state.publicFlashCurrentPage - 1);
      this.setState((prevState) => ({
        publicFlashCurrentPage: prevState.publicFlashCurrentPage - 1,
      }));
    }
  };

  handleNextPage = () => {
    let nextPage = this.state.publicFlashCurrentPage + 1;
    if (
      nextPage >
      Math.ceil(
        this.state.publicFlashTotalRecords /
          this.state.publicFlashRowCountLimit,
      )
    )
      return;
    else {
      this.reRenderPublicFlashCard(nextPage);
      this.setState({ publicFlashCurrentPage: nextPage });
    }
  };

  handlePageChange = (page) => {
    this.reRenderPublicFlashCard(page);
    this.setState({ publicFlashCurrentPage: page });
  };

  reRenderPublicFlashCard = (page) => {
    let offset =
      page * parseInt(this.state.publicFlashRowCountLimit) -
      parseInt(this.state.publicFlashRowCountLimit);
    this.setState({ publicFlashOffset: offset }, function () {
      this.props.getPublicFlashCards(
        this.state.searchText,
        offset,
        this.state.publicFlashRowCountLimit,
      );
    });
  };

  render() {
    return (
      <div className="tt-widgetContent-tab-holder" style={{ height: "79.5vh" }}>
        <div className="tt-group-header">
          List of Flash Cards Set
          {checkWidgetAdminOrNot("Teaching Tools") ? (
            <button
              className="tt-button tt-button-primary float-right permissionBtnCSS"
              onClick={() => {
                this.setState({
                  permissionModal: !this.state.permissionModal,
                });
              }}
            >
              Permissions
            </button>
          ) : null}
        </div>
        <div className="card" style={{ maxHeight: "69.6vh", overflow: "auto" }}>
          {this.state.cardType.map((cType, idx) => {
            return (
              <div key={idx} className="mb-1 pl-2 pr-2 pt-2">
                <div className="container-fluid">
                  <div className="row tt-group-header">
                    <div
                      className={
                        cType.code === "my" ? "col-md-11" : "col-md-3 mt-2"
                      }
                    >
                      {cType.name}
                    </div>
                    {cType.code === "public" ? (
                      <div className="col">
                        <div className="row">
                          <div className="col-md-auto mt-2">
                            <strong>Search: </strong>
                          </div>
                          <div className="col">
                            <input
                              type="text"
                              className="form-control"
                              name="searchText"
                              value={this.state.searchText}
                              onChange={this.handleChange}
                              disabled={cType.open === false}
                            ></input>
                          </div>
                          <div className="col-md-auto mt-1">
                            <button
                              className="tt-button tt-button-primary"
                              disabled={cType.open === false}
                              onClick={this.searchPublicFlashCard}
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div
                      className={
                        "col-md-1 text-center" +
                        (cType.code === "my" ? "" : " mt-2")
                      }
                      style={{ cursor: "pointer" }}
                      onClick={(e) => this.toggleCollapsible(e, idx)}
                    >
                      <FontAwesomeIcon
                        icon={cType.open ? faAngleUp : faAngleDown}
                      ></FontAwesomeIcon>
                    </div>
                  </div>
                  <CustomCollapse
                    isOpen={cType.open}
                    collapsibleBody={this.displayList(cType)}
                  ></CustomCollapse>
                </div>
              </div>
            );
          })}
        </div>
        <ModalWindow
          modal={this.state.updateModal}
          toggleModal={this.toggleUpdateModal}
          modalHeader="Update Flash Cards Set"
          modalBody={
            <UpdateFlashCardSet
              title={this.state.title}
              description={this.state.description}
              access={this.state.access}
              updateFlashCardSet={this.updateFlashCardSet}
              handleChange={this.handleChange}
              toggleUpdateModal={this.toggleUpdateModal}
              flashCardsUpdateModal={this.state.flashCardsUpdateModal}
              handleUpdateFlashCardModal={this.handleUpdateFlashCardModal}
            ></UpdateFlashCardSet>
          }
        ></ModalWindow>
        <CustomModal
          modal={this.state.flashCardsUpdateModal}
          toggleModal={this.handleUpdateFlashCardModal}
          modalHeader="Update Flash Cards"
          fullWidth={true}
          modalBody={
            <UpdateFlashCards
              codeIdx={this.state.codeIdx}
              selectedCard={this.state.selectedCard}
              setSelectedCard={this.setSelectedCard}
              getMyFlashCardsUpdate={this.getMyFlashCardsUpdate}
              handleUpdateFlashCardModal={this.handleUpdateFlashCardModal}
            ></UpdateFlashCards>
          }
        />

        <ModalWindow
          modal={this.state.permissionModal}
          size="lg"
          id="tt-permissionModal"
          toggleModal={() => {
            this.setState({
              permissionModal: !this.state.permissionModal,
            });
          }}
          modalHeader={"Assign permission to user"}
          modalBody={
            <GranularPermissionModal
              widgetName="Teaching Tools"
              moduleName="Flash Cards"
              header="List Flash Cards configuration"
              activityName="list-flash-cards"
            />
          }
        ></ModalWindow>
      </div>
    );
  }
}
const mapStateToProps = (state, props) => ({
  publicFlashCards: state.flashCard.publicFlashCards,
  publicFlashTotalRecords: state.flashCard.publicFlashTotalRecords,
  myFlashCards: state.flashCard.myFlashCards,
  publicSpinner: state.flashCard.publicSpinner,
  mySpinner: state.flashCard.mySpinner,
});

const mapActionsToProps = {
  getPublicFlashCards,
  getMyFlashCards,
};

export default connect(mapStateToProps, mapActionsToProps)(ListFlashCards);
